import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-field-modal',
  templateUrl: './add-field-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-field-modal.component.scss']
})
export class AddFieldModalComponent {
  public fieldForm: FormGroup
  public isLoading: boolean = false
  public isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddFieldModalComponent>,
    @Inject(MAT_DIALOG_DATA) public regionId: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderService: WellHeaderInfoService
  ){}

  ngOnInit(){
    this.fieldForm = this.initializeForm()

    this.fieldForm.get('fieldShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.fieldForm.get('fieldShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      regionId: this.regionId,
      fieldLongName: ['', [Validators.required, noWhitespaceValidator()]],
      fieldShortName: ['', [Validators.required, noWhitespaceValidator()]],
      fieldDescription: '',
      fieldStatus: '',
      blockName: '',
      basinName: '',
      basinType: '',
      remark: '',
    })
  }

  createField(){
    this.wellHeaderService.createFields(this.fieldForm.value).subscribe(
      {
        next: (res) => {
          if(res.isSuccess){
            this.isSuccess = true
            this.closeDialog()
          }

          this.isLoading = false
        },
        error: (err) => this.isLoading = false
      }
    )
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get fieldLongName() {
    return this.fieldForm.get('fieldLongName');
  }

  get fieldShortName() {
    return this.fieldForm.get('fieldShortName');
  }
}


